/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VmcPoolOrgOperationEnum = 'LINK' | 'UNLINK';

export const VmcPoolOrgOperationEnum = {

    LINK: 'LINK' as VmcPoolOrgOperationEnum,

    UNLINK: 'UNLINK' as VmcPoolOrgOperationEnum
};

